import Route from '@ember/routing/route';
import { buildSummaryAttributeChangesets, type SummaryAttributeChangesets } from 'garaje/changesets/summary-attribute';
import type GlobalFlow from 'garaje/models/global-flow';
import type GlobalSummaryPage from 'garaje/models/global-summary-page';
import { hash } from 'rsvp';

import type { LocationOverviewSignInFlowsShowRouteModel } from '../route';

export interface LocationOverviewSignInFlowsShowFinalScreenRouteModel {
  flow: GlobalFlow;
  summaryPage: GlobalSummaryPage;
  summaryAttributeChangesets: SummaryAttributeChangesets;
}

export default class LocationOverviewSignInFlowsShowFinalScreenRoute extends Route {
  async model(): Promise<LocationOverviewSignInFlowsShowFinalScreenRouteModel> {
    const { globalFlow } = <LocationOverviewSignInFlowsShowRouteModel>(
      this.modelFor('location-overview.sign-in-flows.show')
    );
    const summaryPage = await globalFlow.summaryPage;
    const summaryAttributeChangesets = buildSummaryAttributeChangesets(summaryPage);

    return hash({
      flow: globalFlow,
      summaryPage,
      summaryAttributeChangesets,
    });
  }
}
